import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

const encode = (data) => {
	return Object.keys(data)
		.map(
			(key) =>
				encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
		)
		.join('&');
};
const CustomForm = ({ data }) => {
	const [isSuccess, setSuccess] = useState(false);
	const initialValues = data.content.reduce((acc, cur) => {
		if (
			[
				'DatoCmsInput',
				'DatoCmsSelect',
				'DatoCmsCheckbox',
				'DatoCmsPrefix',
			].includes(cur.__typename)
		) {
			return { ...acc, [cur.identifier]: '' };
		}
		return acc;
	}, {});
	const formName = data.identifier;

	return (
		<Formik
			initialValues={initialValues}
			validate={(values) => {
				const errors = {};
				data.content.forEach((input) => {
					if (
						[
							'DatoCmsInput',
							'DatoCmsSelect',
							'DatoCmsCheckbox',
							'DatoCmsPrefix',
						].includes(input.__typename)
					) {
						if (!values[input.identifier]) {
							errors[input.identifier] = `Required`;
						}
					}
				});
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				setSubmitting(true);
				const data = {
					...values,
				};
				console.log(data);
				fetch('/', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: encode({
						'form-name': formName,
						...data,
					}),
				})
					.then(() => {
						setSuccess(true);
					})
					.catch((error) => alert(error));
			}}
		>
			{({ isSubmitting, setFieldValue }) => (
				<Form
					className={`form submit-status-${isSuccess}`}
					id={formName}
					data-netlify='true'
					netlify
					netlify-honeypot='bot-field'
					name={formName}
				>
					<Field type='hidden' name={formName} />
					<Field type='hidden' name='bot-field' />
					{data.content.map((input) => {
						if (input.__typename === 'DatoCmsInput') {
							return (
								<div key={input.id} className='field-option'>
									<Field
										required
										type={input.inputType}
										name={input.identifier}
										id={input.identifier}
										placeholder={`${input.placeholder} *`}
										as={
											input.inputType === 'textarea'
												? 'textarea'
												: undefined
										}
									/>
									<ErrorMessage
										className='error-message'
										name={input.identifier}
										component='span'
									/>
								</div>
							);
						}
						if (input.__typename === 'DatoCmsPrefix') {
							return (
								<div
									key={input.id}
									className='field-option field-option-prefix'
								>
									<div className='prefix'>{input.prefix}</div>
									<Field
										required
										type={input.inputType}
										name={input.identifier}
										id={input.identifier}
										placeholder={`${input.placeholder} *`}
										as={
											input.inputType === 'textarea'
												? 'textarea'
												: undefined
										}
									/>
									<ErrorMessage
										className='error-message'
										name={input.identifier}
										component='span'
									/>
								</div>
							);
						}
						if (input.__typename === 'DatoCmsSelect') {
							return (
								<div key={input.id} className='field-option'>
									<Field
										as='select'
										required
										name={input.identifier}
										id={input.identifier}
										placeholder={`${input.placeholder} *`}
									>
										<option disabled value=''>
											{input.placeholder}
										</option>
										{input.options.map((option) => (
											<option value={option.text}>
												{option.text}
											</option>
										))}
									</Field>
									<ErrorMessage
										className='error-message'
										name={input.identifier}
										component='span'
									/>
								</div>
							);
						}

						if (input.__typename === 'DatoCmsSelect') {
							return (
								<div key={input.id} className='field-option'>
									<Field
										as='select'
										required
										name={input.identifier}
										id={input.identifier}
										placeholder={`${input.placeholder} *`}
									>
										<option disabled value=''>
											{input.placeholder}
										</option>
										{input.options.map((option) => (
											<option value={option.text}>
												{option.text}
											</option>
										))}
									</Field>
									<ErrorMessage
										className='error-message'
										name={input.identifier}
										component='span'
									/>
								</div>
							);
						}
						if (input.__typename === 'DatoCmsButton') {
							return (
								<button
									className={`btn btn--${input.size}`}
									type='submit'
									disabled={isSubmitting}
								>
									{input.emoji !== null && (
										<img
											className='emoji'
											src={input.emoji.image.url}
											alt={input.emoji.image.alt}
										/>
									)}
									<span className='btn-text'>
										{input.text}
									</span>
								</button>
							);
						}
						if (input.__typename === 'DatoCmsCheckbox') {
							return (
								<label
									for={input.identifier}
									className='field-container checkbox'
								>
									<Field
										type='checkbox'
										id={input.identifier}
										name={input.identifier}
										required={input.required}
									/>
									<div className='checkbox_indicator'></div>
									<div className='small-print'>
										{input.text}
									</div>
									{input.required === true && (
										<ErrorMessage
											className='error'
											name={input.identifier}
											component='span'
										/>
									)}
								</label>
							);
						}
						return null;
					})}
					<div className='success-message'>
						<h2>Thanks!</h2>
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default CustomForm;
